import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ShopWindowItem } from "../../model/shop-window-item";
import { OneClickPurchaseInfo } from "../../model/one-click-purchase-info";
import { ProductService } from '../../services/product.service';
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "pme-product-consulta",
    templateUrl: "./product-consulta.component.html",
    styleUrls: ["./product-consulta.component.scss"],
    standalone: false
})
export class ProductConsultaComponent implements OnInit {
  @Input() productData: ShopWindowItem;
  @Input() oneClickPurchaseInfo: OneClickPurchaseInfo;
  @Input() elementIndex: number;
  @Input() shopWindowReduced: boolean;
  @Input() idOneClick: string;
  @Output() buyClicked = new EventEmitter<any>();
  @Output() clickOneClickPurchase = new EventEmitter<{
    changePayment: boolean;
    elementIndex: number;
  }>();
  @Output() calculate = new EventEmitter<void>();
  @Output() exibirBalaoOneClick = new EventEmitter<{
    info: OneClickPurchaseInfo;
    index: number;
    position: { top: number; left: number };
  }>();
  @Output() esconderBalaoOneClick = new EventEmitter<void>();

  isMobile = /mobile|android|iphone|ipad|ipod|blackberry|windows phone/.test(
    navigator.userAgent.toLowerCase()
  );

  showOneClick: boolean = false;
  dropdownOpened: boolean = false;
  isHybridPackageAssinatura: boolean = false;
  textButton: string;
  customPackageValue: number = 0;

  constructor(private elementRef: ElementRef, public productService: ProductService, public snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.calculate) {
      this.calculate.emit();
    }
    this.isHybridPackageAssinatura =
      this.productData.product.classificationIdentifier === "plano-mensal";
    this.textButton = this.isHybridPackageAssinatura ? "ASSINAR" : "COMPRAR";

    if (this.productService.isVariableProduct(this.productData.product)) {
      this.customPackageValue = this.productData.baseValue;
    }

    console.log(
      "ProductConsultaComponent initialized with productData:",
      this.productData
    );
  }

  onBuyClicked(): void {
    const finalValue = this.productService.isVariableProduct(this.productData.product)
      ? this.customPackageValue
      : this.productData.baseValue;

    this.buyClicked.emit({
      i: this.elementIndex,
      customValue: finalValue
    });
  }

  updateCustomPackageValue(value: string) {
    this.customPackageValue = Number(value);
  }

  checkCustomPackageValue(): boolean {
    const minimumValue = this.productData.baseValue;

    if (this.customPackageValue < minimumValue) {
      this.snackBar.open(`O valor mínimo é de R$ ${minimumValue}`, "Fechar", {
        duration: 3000
      });
      this.customPackageValue = minimumValue;
      return false;
    }
    return true;
  }

  formatCurrency(value: number) {
    // O toLocaleString com minimumFractionDigits: 2 já garante o ",00"

    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  onHover(): void {
    if (!this.oneClickPurchaseInfo) {
      return;
    }
    this.showOneClick = true;
    this.mostrarBalao();
  }
  onLeave(): void {
    if (!this.oneClickPurchaseInfo) {
      return;
    }
    this.showOneClick = false;
    this.esconderBalao();
  }

  onClickOneClickPurchase(event: {
    changePayment: boolean;
    elementIndex: number;
  }): void {
    this.clickOneClickPurchase.emit(event);
  }

  onDropClicked(): void {
    this.dropdownOpened = !this.dropdownOpened;
  }

  onClick(): void {
    if (this.isMobile) {
      this.showOneClick = !this.showOneClick;
    }
  }

  checkShowOneClick(): boolean {
    return this.oneClickPurchaseInfo ? true : false;
  }

  mostrarBalao() {
    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    this.exibirBalaoOneClick.emit({
      info: this.oneClickPurchaseInfo,
      index: this.elementIndex,
      position: {
        top: rect.bottom,
        left: rect.left,
      },
    });
  }

  esconderBalao() {
    setTimeout(() => {
      this.esconderBalaoOneClick.emit();
    }, 300); // tempo suficiente para o usuário mover o mouse para o balão
  }
}
